import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocationItem } from './common';

@Injectable()
export class NotificationService {
  constructor(private httpClient: HttpClient) {}

  public getNotifications(request: any): Promise<LocationItem[]> {
    const APIHost = 'unknown';
    const subjectId = 'unknown';
    const typeId = 'unknown';

    const url = APIHost + `?subjectId=${subjectId}&typeId=${typeId}`;
    const headers = new HttpHeaders({
      Accept: '*/*'
    });

    return this.httpClient
      .get(url, { headers: headers })
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('Error getting name suggestions from a name suggestion service.');
    return Promise.reject(error.message || error);
  }
}
